<!--
 * @Author: your name
 * @Date: 2020-02-18 17:19:14
 * @LastEditTime: 2020-02-26 13:30:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \handlephoto\src\views\orderPreview.vue
 -->
<template>
  <div class="orderPreview">
    <div class="wrp">
      <div class="ant-upload ant-upload-drag main-col flex-center">
        <div class="img-wrap">
          <img
            v-show="oList.length"
            :src="oList.length&&oList[0].pic_url"
            ref="img"
            ondragstart="return false;"
            class="upload-img"
            alt
          />
        </div>
      </div>
      <sideBar class="sidebar-col" title="我的照片" subTitle="照片仅保存7天" iconType="folder-open">
        <div class="oPreview flex sidebar-con">
          <orderList :isOrderPreview="true" :oList="oList"></orderList>
        </div>
      </sideBar>
    </div>
  </div>
</template>
<script>
import sideBar from "@/components/sidebar.vue";
import orderList from "@/components/orderList.vue";
import { queryOrder } from "@/utils/api";
import download from "downloadjs";
export default {
  data() {
    return {
      url: "",
      isLogin: false,
      loginModal: false,
      rulePopVisible: false,
      oList: []
    };
  },
  components: {
    sideBar,
    orderList
  },
  mounted() {
    this.getOList();
    this.init();
  },
  methods: {
    init() {
      this.$refs.img.addEventListener("load", () => {
        if (this.$refs.img.width > 944) {
          this.$refs.img.width = this.$refs.img.width / 2;
          return;
        }
        if (this.$refs.img.height > 808) {
          this.$refs.img.height = this.$refs.img.width / 2;
          return;
        }
      });
    },
    loginBtnFn() {
      this.loginModal = true;
    },
    cancel() {
      this.loginModal = false;
    },
    downloadIamge(imgsrc, name = "photo") {
      let _self = this;
      const hide = this.$message.loading("下载中...", 0);
      var x = new XMLHttpRequest();
      x.open("GET", imgsrc, true);
      x.responseType = "blob";
      x.onload = function(e) {
        download(x.response, name + ".jpg", "image/jpg");
        setTimeout(hide, 500);
      };
      x.send();
    },
    getOList() {
      let orderno = this.$route.query.orderno;
      queryOrder(orderno).then(res => {
        if (res.state === "completed") {
          res.colours = JSON.parse(res.colours);
          this.oList.push(res);
          this.url = res.pic_url;
          if (res.zip_url === null) {
            this.downloadIamge(res.pic_url);
            return;
          } else {
            location.href = res.zip_url;
          }
        }
      });
    }
  }
};
</script>
<style scoped>
.oPreview {
  height: calc(100% - 44px);
}
.img-wrap {
  max-width: 80%;
  /* height: 80%; */
  /* width: 409px; */
  height: auto;
  max-height: 80%;
  display: inline-block;
}
.upload-img {
  /* width: 100%; */
  /* max-height: 100%; */
}
</style>